import { useEffect, useState } from "react";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function YearlyOntimeDeliveryRateKpi (props){

    const table = "VwDeliveryComplianceYearly";
    const view = "VwDeliveryComplianceYearly";

    const { filterValue, onFilterInitialized, onSearchInitialized, onModifyViewSchema } = props;

    const [ api, setApi ] = useState ( null );

    useEffect ( () => {

        if ( api ) {

            api.refresh ();

        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ api ] );


    const onApiInitialized = ( api ) => {

        setApi ( api );

    };

    return (
    
        <BasicCrudScreenType
            id="YearlyOntimeDeliveryRateKpi"
            noHeader
            table={table}
            view={view}
            extFilterValue={filterValue}
            onFilterInitialized={onFilterInitialized}
            onSearchInitialized={onSearchInitialized}
            onModifyViewSchema={onModifyViewSchema}
            onApiInitialized={onApiInitialized}
        />

    );

}
export default YearlyOntimeDeliveryRateKpi;